<template>
    <Section
        width="sm"
        class="post-card-info"
    >
        <div class="container">
            <div class="container-inner">
                <PrismicImage
                    :img="card.data.card_image"
                    w="250"
                />
                <ButtonTarget
                    :link="card"
                    placement="credit-card"
                    enable-apply-securely-text
                />
            </div>

            <div class="container-inner">
                <h3>{{ card.data.title }}</h3>

                <Stars
                    v-if="model._ratings"
                    :rating="model._ratings.average_score"
                />
                <ButtonNuxt
                    :link="card"
                    :text="$translate('cta_read_more', 'Läs mer')"
                    icon="fas fa-arrow-right"
                    background="yellow"
                    size="sm"
                />

                <ListCardInfo :data="card" :model="model" />
            </div>
        </div>
    </Section>
</template>

<script>
import Stars from '@/components/stars/Stars.vue';
export default {
    components: { Stars },
    props: {
        slice: {
            type: Object,
            required: true,
            default: () => {}
        }
    },
    computed: {
        card() {
            return this.$store.state.cards[this.slice.primary.cc_card.id];
        },
        model() {
            return new this.$models.CreditCard(this.card);
        },
    }
};
</script>

<style lang="scss" scoped>
    .container {
        @include flex(center,start);

        &-inner {

            &:first-child {
                @include grid(1, 10px);
                text-align: center;
            }

            &:last-child {
                @include grid(1, 20px);
                flex: 1;
                padding-top: 20px;
                text-align: center;

                @include device(pad) {
                    padding-top: 0;
                    text-align: left;
                    padding-left: 40px;
                }

                .btn {
                    @include device(mobile) { margin: auto; }
                    max-width: 200px;
                }

                ul {
                    @include border(top);
                    padding-top: 10px;
                }
            }
        }
    }
</style>
